export default __webpack_public_path__ + "static/media/myata_banner.5ebb1fd3.svg";